'use strict';

import angular from 'angular';
import template from './modal.pug';

const GrpFeeAmtModalSvc = [
  'ModalSvc',
  'LoaderSvc',
  'DatetimeSvc',
  'GrpTypeSvc',
  'GrpFeeSvc',
  function(
    ModalSvc,
    LoaderSvc,
    DatetimeSvc,
    GrpTypeSvc,
    GrpFeeSvc
  ) {
    /**
     * Opens the group Modal
     * @param  {Object} currentAmounts
     * @param  {string} groupId
     * @param  {string} personId
     * @return {Object}
     */
    function open(currentGrpFee, amountType, groupId) {
      var amountTypesArray = ['amounts', 'adjustments'];
      for(var i in amountTypesArray) {
        var at = amountTypesArray[i];
        currentGrpFee[at].map(DatetimeSvc.getFormDateRange);
        currentGrpFee[at].map(function(a) {
          if(a.groupType) { a.groupTypeId = a.groupType.id; }
          a.formAmount = Number(a.amount) / 100;
          return a;
        });
      }

      // copy current amounts value for updates
      var amountsvm = angular.copy(currentGrpFee[amountType]);

      var modalvm = {
        currentGrpFee,
        amountsvm
      };
      var modalInstance;

      //////////////////////////////////////////////////////////////////////////
      ///  Edit Amount Date Ranges
      //////////////////////////////////////////////////////////////////////////
      function changeStart(item) {
        var formStart = new Date(item.formStart);
        var formEnd;
        // reset end if start is updated
        if(item.formEnd) { formEnd = new Date(item.formEnd); }
        if(formEnd && formEnd < formStart) { item.formEnd = null; }
      }

      function clearEnd(item) {
        item.formEnd = null;
        modalvm.editformvm.$setDirty();
      }

      function addAmount() {
        amountsvm.push({});
      }

      function removeAmount(index) {
        amountsvm.splice(index, 1);
        modalvm.editformvm.$setDirty();
      }

      GrpTypeSvc.getDesc({groupId}).$promise
        .then(function(gt) {
          gt.map(function(type) {
            type.id = Number(type.id);
            return type;
          });
          modalvm.groupTypes = gt;
        });

      /**
       * AngularUI Datepicker
       * NOTE: can open multiple datepickers at a time
       */
      modalvm.dateFormat = 'M/d/yyyy';
      function openDatePick($event, amt, dateType) {
        $event.preventDefault();
        $event.stopPropagation();
        amt[dateType + 'Open'] = true;
      }

      //////////////////////////////////////////////////////////////////////////
      ///  Submit Amounts Updates
      //////////////////////////////////////////////////////////////////////////
      function onSubmit() {
        modalvm.submitted = true;
        if(modalvm.editformvm.$pristine) { return modalInstance.close(); }
        if(modalvm.editformvm.$invalid) { return; }

        LoaderSvc.start();

        // convert form values back for submission
        amountsvm.map(DatetimeSvc.setDatesBasedOnForm);
        amountsvm.map(function(a) {
          a.amount = String(Math.round(a.formAmount * 100));
          return a;
        });
        var editGrpFee = angular.copy(currentGrpFee);
        editGrpFee[amountType] = amountsvm;

        var params = {groupId: currentGrpFee.toGroup.id,
          id: currentGrpFee.id};
        return GrpFeeSvc.update(params, editGrpFee).$promise
          .then(function() {
            currentGrpFee[amountType] = editGrpFee[amountType];
            LoaderSvc.stopSuccess('Member Dues/Fee Amounts Updated');
            modalInstance.close(modalvm.groups);
          })
          .catch(function(e) {
            LoaderSvc.stopError('System Error: ' + e);
          });
      }

      function onCancel() {
        modalInstance.dismiss();
      }

      //////////////////////////////////////////////////////////////////////////
      ///  Set Modal Scope
      //////////////////////////////////////////////////////////////////////////
      var modalScope = {modalvm: angular.extend(modalvm,
        {
          dismissable: true,
          // edit groups
          changeStart, clearEnd, addAmount, removeAmount, openDatePick,
          // modal settings
          title: 'Edit Amounts',
          buttons: [
            {classes: 'btn-primary', text: 'Update Amounts', click: onSubmit},
            {classes: 'btn-default', text: 'Close', click: onCancel}
          ]
        })
      };

      var options = {size: 'lg', template};

      modalInstance = ModalSvc.open(modalScope, options);
      return modalInstance.result;
    }

    // Public API here
    return {
      open
    };
  }
];
export default GrpFeeAmtModalSvc;
